var _rect, _path, _path2, _path3, _path4, _line;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3.04999,
    width: 16.1,
    height: 14.95,
    rx: 2,
    stroke: "#003393",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24995 1.9V2.55H4.94995V1.9C4.94995 1.54101 5.24097 1.25 5.59995 1.25C5.95894 1.25 6.24995 1.54101 6.24995 1.9Z",
    fill: "#003393",
    stroke: "#003393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.15 1.9V2.55H11.85V1.9C11.85 1.54101 12.141 1.25 12.5 1.25C12.859 1.25 13.15 1.54101 13.15 1.9Z",
    fill: "#003393",
    stroke: "#003393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.85 3.9125L11.85 3.2625L13.15 3.2625L13.15 3.9125C13.15 4.27149 12.859 4.5625 12.5 4.5625C12.141 4.5625 11.85 4.27149 11.85 3.9125Z",
    fill: "#003393",
    stroke: "#003393"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95 3.9125L4.95 3.2625L6.25 3.2625L6.25 3.9125C6.25 4.27149 5.95899 4.5625 5.6 4.5625C5.24102 4.5625 4.95 4.27149 4.95 3.9125Z",
    fill: "#003393",
    stroke: "#003393"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.1,
    y1: 8.64999,
    x2: 0.999975,
    y2: 8.64999,
    stroke: "#003393",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.6b1584ee71222267a2c47102fa1ddb2c.svg";
export { ForwardRef as ReactComponent };